import { Component, Input } from '@angular/core'
import { SmartQuoteListItem } from 'src/app/shared/interfaces/smartquote/smart-quote-list-item.interface'
import { RouterLink } from '@angular/router'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { ButtonComponent } from 'src/app/shared/components/form-elements/button/button.component'
import { DateDirective } from 'src/app/shared/directives/date.directive'
import { StaffInlineComponent } from 'src/app/shared/components/staff/staff-inline/staff-inline.component'
import { CurrencyPipe, DatePipe } from '@angular/common'
import { TableModule } from 'src/app/shared/components/table/table.module'

@Component({
    selector: 'sf-smartquote-table',
    imports: [
        RouterLink,
        TableModule,
        StaffInlineComponent,
        ButtonComponent,
        FontAwesomeModule,
        DateDirective,
        CurrencyPipe,
        DatePipe,
    ],
    templateUrl: './smartquote-table.component.html',
    styleUrls: ['./smartquote-table.component.scss'],
})
export class SmartquoteTableComponent {
    @Input() smartQuotes: SmartQuoteListItem[] = []
}
